import { BaseService } from '@/modules/Core/services/BaseService'
import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import type { AxiosResponse } from 'axios'
import type {  IInvoiceDataico } from '@/modules/Financiera/interfaces/ICuentaCobro'

// Interfaz para la respuesta de Dataico que envuelve los datos en { ok, data }
interface IDataicoResponse<T> {
  ok: boolean
  data: T
}

export class ResponseDianService extends BaseService<IInvoiceDataico> {
  constructor() {
    super({
      baseUrl: 'financiera/respuesta-dian/'
    })
  }
  async getResponseDianByFacturaId(
    invoiceId: number
  ): Promise<AxiosResponse<IResponseApi<IDataicoResponse<IInvoiceDataico>>>> {
    return this.http.get<IResponseApi<IDataicoResponse<IInvoiceDataico>>>(`/getOneInvoiceId/${invoiceId}`)
  }

}
